export default __webpack_public_path__ + "static/media/image-amec.1ea8956f.svg";